import React from 'react';
import './custom.css'

const OurMission = () => {
    return (
        <div className='mission_div'>
            <section id='mission' className='mx-3 mx-md-5 '>
                <div>
                    <div className='row'>
                        <div className='col-md-6 d-flex justify-content-center align-items-center'>
                            <div>
                                <div className='text-start '>
                                    <h1 data-aos="flip-up" className='mission_header'>Our Mission</h1>
                                    <span data-aos="fade-up" data-aos-duration="2000" className='mission_span'>A ​carbon neutral planet</span>
                                </div>
                                <p data-aos="fade-up" data-aos-duration="2000" className='mission_Para'>Kyoto, 1977. The United Nations' Intergovernmental Panel on Climate Change (IPCC) developed a carbon credit proposal to reduce worldwide carbon emissions, “the Kyoto Protocol”.
                                    Carbon credits projects have since had a long history, but under-delivered progress on climate change. No project has reduced emissions meaningfully across the world as they failed to empower most people. Digital advancements place us at the inflection point to do this now. O2Club's mission is to build a collaborative platform that will bring transparency and traceability to actions for good, that achieve global low-carbon transition goals. It delivers by leveraging IoT, connected sensors, and blockchain technology.
                                </p>
                            </div>
                        </div>
                        <div className='col-md-6 d-flex justify-content-center align-items-center mt-5 mt-md-0'>
                            <img src='/img/Group.svg' width="70%" alt="" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default OurMission;